import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpInterceptor, HttpContextToken
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { APP_NAME } from './app-config';

export const AUTHORIZATION = new HttpContextToken(() => `Bearer ${window.localStorage.getItem('token')}`);
export const SINGLE_AUTH_HEADER = new HttpContextToken(() => false);
export const DAPI_AUTH = 'Basic dXNlcjpEV2U4aFFmQkRkZXlIOXBqTkRxdQ==';
export const CONTENT_TYPE = new HttpContextToken(() => 'application/json');

export class HttpIntercept implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const ip = btoa('0.0.0.0');
    const url = btoa(`${environment.gatewayBase}`);
    const profile = JSON.parse(window.localStorage.getItem('profile') as string);
    const modifiedReq = request.clone({
      headers: request.headers.set('Authorization', request.context.get(AUTHORIZATION))
        .set('X-ip', ip)
        .set('X-url', url)
        .set('X-external', 'false')
        .set('X-username', (profile) ? btoa(profile.login) : '')
        .set('X-TenantID', btoa(environment.tenantCode))
        .set('Content-Type', request.context.get(CONTENT_TYPE))
        .set('X-app-name', APP_NAME)
    });
    return next.handle(modifiedReq)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (
            error instanceof HttpErrorResponse &&
            !modifiedReq.url.includes('api/authenticate') &&
            error.status === 403
          ) {
            return this.handleAuthError(modifiedReq, next);
          }
          return throwError(error);
        })
      );
  }

  private handleAuthError(request: HttpRequest<any>, next: HttpHandler) {
    window.localStorage.clear();
    return next.handle(request);
  }
}

